import styled from 'styled-components';

export const StyledHr = styled('hr')`
  width: 100%;
  height: 1px;
  background-color: #d9d9d9;
  border: 1px;
`;
